import Vue from 'vue'
import VueRouter from 'vue-router'

import HomeIndex from '../views/home/index/index.vue'
import demo from '@/router/demo'
import personnelAdministration from '@/router/personnelAdministration'
import quickFindResult from '@/router/quickFindResult'
import paymentWelfare from '@/router/paymentWelfare'
import customDisplay from '@/router/customDisplay'
import vehicleOilCard from '@/router/vehicleOilCard'
import qualityManage from '@/router/qualityManage'
import claimsSettlement from '@/router/claimsSettlement'
import arbitration from '@/router/arbitration'
import signTheReceipt from '@/router/signTheReceipt'
import singleDepot from '@/router/singleDepot'
import signBack from '@/router/signBack'
import sendTheReceipt from '@/router/sendTheReceipt'
import reportTpl from '@/router/reportTpl'
import receiptManagement from '@/router/receiptManagement'
import smsPlatform from '@/router/smsPlatform'
import pushManage from '@/router/pushManage'
import systemAlert from '@/router/systemAlert'
import checkSheet from '@/router/checkSheet'
import customerProfiles from '@/router/customerProfiles'
import transportResources from '@/router/transportResources'
import checkImg from '@/router/checkImg'
import gpyTakePhotos from '@/router/gpyTakePhotos'
import uploadImg from '@/router/uploadImg'
import settlement from '@/router/settlement'
import vehicleXinghao from '@/router/vehicleXinghao'
import priceSystem from '@/router/priceSystem'
import MybSupplyManagement from '@/router/MybSupplyManagement'
import fdpz from '@/router/fdpz'
import ManYunBao from '@/router/ManYunBao'
import courier from '@/router/courier'
import printbq from '@/router/printbq'
import wTTX from '@/router/wTTX'
import sendPack_SB from '@/router/sendPack_SB'
import deliveryRecord from '@/router/deliveryRecord'
import myAccount from '@/router/myAccount'
import acceptanceOfBill2 from '@/router/acceptanceOfBill2'
import truckPositioning from '@/router/truckPositioning'
import notice from '@/router/notice'
import zzjg from '@/router/zzjg'
import permissionGroup from '@/router/permissionGroup'
import czy from '@/router/czy'
import BindingEquipment from '@/router/bindingEquipment'
import ParmSetting from '@/router/parmSetting'
import rptMana from '@/router/rptMana'
import LinePrintSetting from '@/router/linePrintSetting'
import baseSetting from '@/router/baseSetting'
import toggleSite from '@/router/toggleSite'
import sysMana from '@/router/sysMana'
import ImportTemplate from '@/router/ImportTemplate'
import customerInformationTemplate from '@/router/customerInformationTemplate'
import goodsTrackingTemplate from '@/router/goodsTrackingTemplate'
import warehouseManagement from '@/router/warehouseManagement'
import zyDownload from '@/router/zyDownload'
import dataDictionary from '@/router/dataDictionary'
import billingCustom from '@/router/billingCustom'
import areaData from '@/router/areaData'
import weixinCoupon from '@/router/weixinCoupon'
import wXAccount from '@/router/wXAccount'
import calculator from '@/router/calculator'
import accInfo from '@/router/accInfo'
import home from '@/router/home'
import newCW_Detail from '@/router/newCW_Detail'
import cashDayAccount from '@/router/cashDayAccount'
import financialReconciliation from '@/router/financialReconciliation'
import acceptanceOfBill from '@/router/acceptanceOfBill'
import commomRouter from '@/router/commomRouter'
import financialPreparation from '@/router/financialPreparation'
import bankPrepare from '@/router/bankPrepare'
import importWarehouse from '@/router/importWarehouse'
import inventoryManagement from '@/router/inventoryManagement'
import newWarehouseManagement from '@/router/newWarehouseManagement'
import newInventoryManagement from '@/router/newInventoryManagement'
import cCAccBaseInfo from '@/router/cCAccBaseInfo'
import cCCashDayAccount from '@/router/cCCashDayAccount'
import cCWriteOffDetailed from '@/router/cCWriteOffDetailed'
import libraryTemplate from '@/router/libraryTemplate'
import oP from '@/router/oP'
import flowChart from '@/router/flowChart'
import writeOffDetailed from '@/router/writeOffDetailed'
import pleaseInquire from '@/router/pleaseInquire'
import payment from '@/router/payment'
import newCW from '@/router/newCW'
import forPayment from '@/router/forPayment'
import cashier from '@/router/cashier'
import news from '@/router/news'
import cashClassReport from '@/router/cashClassReport'
import financialInstruments from '@/router/financialInstruments'
import carFreightChange from '@/router/carFreightChange'
import billing from '@/router/billing'
import pressForMoney from '@/router/pressForMoney'
import otherFee from '@/router/otherFee'
import changeClassReport from '@/router/changeClassReport'
import pay from '@/router/pay'
import webOrder from '@/router/webOrder'
import outgoingRegistration from '@/router/outgoingRegistration'
import waybillImport from '@/router/waybillImport'
import shortHauls from '@/router/shortHauls'
import fhkc from '@/router/fhkc'
import operationClassReport from '@/router/operationClassReport'
import test from '@/router/test'
import trackingInTransit from '@/router/trackingInTransit'
import ztgz from '@/router/ztgz'
import maps from '@/router/maps'
import dhqr from '@/router/dhqr'
import arrivalInventory from '@/router/arrivalInventory'
import customerPickUp from '@/router/customerPickUp'
import qsRegister from '@/router/qsRegister'
import workOrder from '@/router/workOrder'
import workOrderCenter from '@/router/workOrderCenter'
import account from '@/router/account' //所有登录页
import deposit from '@/router/deposit'
import location from '@/router/location'
import storageManage77838 from '@/router/storageManage77838'
import hlht from '@/router/hlht'
import warehous80548 from '@/router/warehous80548'
import sLManage from '@/router/sLManage'
import uploadUserAvatar from '@/router/uploadUserAvatar'
import billManagement from '@/router/billManagement'
import kPImanage from '@/router/kPImanage'
import vehiclemanage from '@/router/vehiclemanage'
import customerRecKpi from '@/router/customerRecKpi'
import upsteamOrder from '@/router/upsteamOrder'
import productlibrary from '@/router/productlibrary'
import accountStatement from '@/router/accountStatement'
import loadpage from '@/router/loadpage' // 加载页面
import hYInfo from '@/router/hYInfo'
import cYInfo from '@/router/cYInfo'
import leaveState from '@/router/leaveState'
import printProblem from '@/router/printProblem'
import zXB from '@/router/zXB'
import updateRecord from '@/router/updateRecord'
import taskList from '@/router/taskList'

import error from '@/views/404.vue'
import error403 from '@/views/403.vue'
import authorityCheck from '@/utils/authorityCheck'
import weCom from '@/router/weCom'
import newLqMall from '@/router/newLqMall'
import newChart from '@/router/newChart'
import aiTool from '@/router/aiTool'
import endCost from '@/router/endCost'
import xjdcContainer from '@/router/xjdcContainer'
import landingDispatch from '@/router/landingDispatch'
import ckRegister from '@/router/ckRegister'
import newPriceStandard from './newPriceStandard'
import selfPickup from '@/router/selfPickup'
import trajectoryLog from '@/router/trajectoryLog'
import combinePackage from '@/router/combinePackage'

Vue.use(VueRouter)
/**
 * warning warning warning
 * 所有的路由请和原系统保持一致，有些请求是相对路径
 */
let routes = [
    {
        path: '/',
        name: 'home',
        component:  HomeIndex
    },
    {
        path: '/error403',
        name: 'error403',
        component: error403
    },
    ...demo,
    ...personnelAdministration,
    ...paymentWelfare,
    ...qualityManage,
    ...claimsSettlement,
    ...arbitration,
    ...signTheReceipt,
    ...sendTheReceipt,
    ...singleDepot,
    ...signBack,
    ...reportTpl,
    ...receiptManagement,
    ...vehicleOilCard,
    ...quickFindResult,
    ...customDisplay,
    ...smsPlatform,
    ...pushManage,
    ...systemAlert,
    ...checkSheet,
    ...customerProfiles,
    ...transportResources,
    ...checkImg,
    ...gpyTakePhotos,
    ...uploadImg,
    ...settlement,
    ...vehicleXinghao,
    ...priceSystem,
    ...MybSupplyManagement,
    ...ManYunBao,
    ...courier,
    ...printbq,
    ...wTTX,
    ...sendPack_SB,
    ...deliveryRecord,
    ...myAccount,
    ...fdpz,
    ...truckPositioning,
    ...notice,
    ...zzjg,
    ...czy,
    ...BindingEquipment,
    ...ParmSetting,
    ...rptMana,
    ...LinePrintSetting,
    ...baseSetting,
    ...toggleSite,
    ...sysMana,
    ...ImportTemplate,
    ...customerInformationTemplate,
    ...goodsTrackingTemplate,
    ...warehouseManagement,
    ...zyDownload,
    ...dataDictionary,
    ...billingCustom,
    ...areaData,
    ...weixinCoupon,
    ...acceptanceOfBill,
    ...calculator,
    ...wXAccount,
    ...acceptanceOfBill2,
    ...newCW_Detail,
    ...cashDayAccount,
    ...financialReconciliation,
    ...commomRouter,
    ...financialPreparation,
    ...bankPrepare,
    ...permissionGroup,
    ...importWarehouse,
    ...inventoryManagement,
    ...newWarehouseManagement,
    ...newInventoryManagement,
    ...cCAccBaseInfo,
    ...cCCashDayAccount,
    ...cCWriteOffDetailed,
    ...accInfo,
    ...home,
    ...libraryTemplate,
    ...oP,
    ...flowChart,
    ...writeOffDetailed,
    ...pleaseInquire,
    ...payment,
    ...newCW,
    ...forPayment,
    ...cashier,
    ...news,
    ...cashClassReport,
    ...financialInstruments,
    ...carFreightChange,
    ...billing,
    ...pressForMoney,
    ...otherFee,
    ...changeClassReport,
    ...pay,
    ...webOrder,
    ...outgoingRegistration,
    ...waybillImport,
    ...shortHauls,
    ...fhkc,
    ...operationClassReport,
    ...test,
    ...trackingInTransit,
    ...ztgz,
    ...maps,
    ...dhqr,
    ...arrivalInventory,
    ...customerPickUp,
    ...qsRegister,
    ...workOrder,
    ...workOrderCenter,
    ...account,
    ...deposit,
    ...location,
    ...storageManage77838,
    ...hlht,
    ...warehous80548,
    ...sLManage,
    ...uploadUserAvatar,
    ...billManagement,
    ...kPImanage,
    ...vehiclemanage,
    ...customerRecKpi,
    ...upsteamOrder,
    ...productlibrary,
    ...accountStatement,
    ...loadpage,
    ...hYInfo,
    ...cYInfo,
    ...leaveState,
    ...printProblem,
    ...zXB,
    ...updateRecord,
    ...taskList,
    ...newLqMall,
    ...weCom,
    ...newChart,
    ...aiTool,
    ...endCost,
    ...xjdcContainer,
    ...landingDispatch,
    ...ckRegister,
    ...newPriceStandard,
    ...selfPickup,
    ...trajectoryLog,
    ...combinePackage
]

routes.push({
    path: '*',
    name: 'ErrorPage',
    component: error
})
const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})
router.beforeEach((to: any, from: any, next: any) => {
    if (to.query.proxyOperateFlag) {
        // 客服代操作需求，从后台获取链接进入，免登需先清除内存信息
        sessionStorage.clear();
        document.cookie.split(";").forEach(function(c) {
            document.cookie = c.trim().split("=")[0] + '=;expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/';
        });
    }
    // 登录状态判断
    const currentWindow: any = window
    const pathname = to.path.toLowerCase()
    const isLoginPage = account.some(item => item.path.toLowerCase() == pathname)
    const isLogined = currentWindow.$.cookie('requesttoken')
    const Location = currentWindow.top.location
    if (isLoginPage) {
        if (isLogined && !to.query.requesttoken) {
            if (pathname === '/Settlement/Login'.toLowerCase()) {
                next({ path: '/Settlement/HomeIndex' })
            } else if (pathname === '/MybSupplyManagement/Login'.toLowerCase()) {
                next({ path: '/MybSupplyManagement/HomeIndex' })
            } else {
                next({ path: currentWindow.$.cookie('HOMEPAGE_VERSION') == 'V2' ? '/home/indexV2' :  '/home/index' })
            }
            return
        }
    } else {
        const isRoutePage = routes.some(item => item.path.toLowerCase() == pathname)
        const isLoadpageFromOfficialWeb = pathname == '/loadpage/index' && to.query.token // 从官网跳转到加载页
        if (!isLogined && isRoutePage && !isLoadpageFromOfficialWeb) {
            // 登录信息失效了，需要重定向到登录页
            const isHomePage = ['/', '/home/index', '/Settlement/HomeIndex', '/MybSupplyManagement/HomeIndex'].some(
                item => item.toLowerCase() == pathname
            )
            const url = currentWindow.getLoginPageAndClearData()
            if (isHomePage) {
                // 进入首页，但登录信息失效了，直接重定向到登录页或官网
                Location.replace(url)
            } else {
                currentWindow.top.ShowERR('登录信息已过期，请重新登录', () => {
                    Location.replace(url)
                })
            }
            return
        }

        // 权限检验
        const checkResult = authorityCheck.start(to.path, to.query)
        if (checkResult === 0 || checkResult === 2) {
            next({ name: 'error403', params: { authorityCheckResult: checkResult } })
            return
        } else if (checkResult === -1) {
            next({ name: 'ErrorPage', params: { authorityCheckResult: checkResult } })
            return
        }
    }
    next()
})

export default router
